export const MIN_HEIGHT_CM = 0; // 0FT
export const MAX_HEIGHT_CM = 304.8; // 10FT

export const CM_PER_INCH = 2.54;
export const INCHES_PER_FOOT = 12;
export const FEET_INPUT_NAME = 'heightFeet';
export const INCHES_INPUT_NAME = 'heightInches';
